module.exports = __webpack_public_path__ + "img/start.a4e4c21b.svg";